<template>
  <div>
    <!-- Trackable Ad 2 Image -->
    <v-img
      src="../assets/2.png"
      @click="handleClick"
      style="cursor: pointer;max-height:95vh"
      contain

    ></v-img>


  </div>
</template>

<script>
import { onMounted } from 'vue';
import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  updateDoc,
  increment
} from "firebase/firestore";
import { firebaseApp } from "../firebaseConfig";

const db = getFirestore(firebaseApp);

export default {
  name: 'TrackableImageAd2',
  data() {
    return {
      ad2Views: 0,
      ad2Clicks: 0
    };
  },
  async mounted() {
    // Increment view count on mount, then fetch latest stats
    await this.incrementAd2View();
    await this.fetchAd2Stats();
  },
  methods: {
    // Fetch the current ad2Views and ad2Clicks from Firestore
    async fetchAd2Stats() {
      const statsRef = doc(db, 'durbanjuly_farpost_stats', 'counts');
      const statsSnap = await getDoc(statsRef);
      if (statsSnap.exists()) {
        const data = statsSnap.data();
        this.ad2Views = data.ad2Views || 0;
        this.ad2Clicks = data.ad2Clicks || 0;
      } else {
        // If doc doesn't exist yet, initialize local state
        this.ad2Views = 0;
        this.ad2Clicks = 0;
      }
    },

    // Increment the Ad 2 view count
    async incrementAd2View() {
      const statsRef = doc(db, 'durbanjuly_farpost_stats', 'counts');
      const statsSnap = await getDoc(statsRef);
      if (statsSnap.exists()) {
        await updateDoc(statsRef, {
          ad2Views: increment(1)
        });
      } else {
        await setDoc(statsRef, {
          ad2Views: 1,
          ad2Clicks: 0
        });
      }
    },

    // Increment the Ad 2 click count
    async incrementAd2Click() {
      const statsRef = doc(db, 'durbanjuly_farpost_stats', 'counts');
      const statsSnap = await getDoc(statsRef);
      if (statsSnap.exists()) {
        await updateDoc(statsRef, {
          ad2Clicks: increment(1)
        });
      } else {
        await setDoc(statsRef, {
          ad2Views: 0,
          ad2Clicks: 1
        });
      }
    },

    // Handle click: update Firestore, refresh stats, then open landing page in new tab
    async handleClick() {
      await this.incrementAd2Click();
      await this.fetchAd2Stats();
      window.open(
        'http://static.clvads.com/durbanjuly_farpost/index.html',
        '_blank',
        'noopener,noreferrer'
      );
    }
  }
};
</script>

<style scoped>
.v-image--image {
  transition: opacity 0.3s ease;
}
.v-image--image:hover {
  opacity: 0.8;
}
.ad-stats p {
  margin: 0.25rem 0;
  font-size: 0.9rem;
}
</style>
